<script setup lang="ts">
type SelectOption = {
  label: string;
  value: string | number | boolean | null | undefined | string[];
};

defineProps<{
  id?: string;
  name?: string;
  value?: string | number | boolean | null | undefined | string[];
  options?: SelectOption[];
}>();

const emit = defineEmits<{
  change: [value: string];
}>();

const onChange = (event: Event) => {
  const target = event.target as HTMLSelectElement;
  const rawValue = target.value;
  emit("change", rawValue);
};
</script>

<template>
  <select
    :id="id"
    :value="value"
    :name="name"
    class="py-1 pl-1 pr-0.5 ml-2 text-base border focus:z-10 focus:ring-2 ring-slate-200 ring-offset-2 ring-offset-slate-500 border-transparent bg-slate-100 focus:outline-none"
    @change="onChange"
  >
    <template v-for="option in options" :key="String(option.value)">
      <option :value="option.value">{{ option.label }}</option>
    </template>
  </select>
</template>
